import context from '@/context'
import { push } from 'react-router-redux'
import { MessagesTabs } from '@/enums/MessagesTabs'
import { openErrorDialog } from '@/utils/dialogHelpers'

export const initialState = {

  msg: [],
  replyMsg: [],
  fetching: false,
  fetched: false,
  error: null,

  parentId: null,
  replyMessageListFetching: false,
  replyMessageListFetched: false,

  message: {},
  replyMessage: {},
  attachments: [],
  replyAttachments: [],
  retrieving: false,
  retrieved: false,
  replyRetrieving: false,
  replyRetrieved: false,

  createMessageFetching: false,
  createMessageFetched: false,
  data: null,

  lastReloadedAtDraft: new Date(),
  lastReloadedAtSent: new Date()
}

export const actionTypes = {

  messagesFetching: 'messages/fetching',
  messagesFetched: 'messages/fetched',
  messagesFetchingError: 'messages/errorOccurred',

  messageRetrieving: 'messages/retrieving',
  messageRetrieved: 'messages/retrieved',
  messageReplyRetrieving: 'messages/messageReplyRetrieving',
  messageReplyRetrieved: 'messages/messageReplyRetrieved',
  messageRetrievingError: 'messages/retrievingError',

  messageDeleting: 'messages/deleting',
  messageDeleted: 'messages/deleted',
  messageDeletingError: 'messages/deletingError',

  messageAddOrUpdate: 'messages/messageAddOrUpdate',
  messageAddedOrUpdated: 'messages/messageAddedOrUpdated',

  messageSending: 'messages/messageSending',
  messageSent: 'messages/messageSent',
  messageSendingError: 'messages/messageSendingError',

  updateDto: 'messages/updateDto',
  updateReplyDto: 'messages/updateReplyDto',
  clearDto: 'messages/clearDto',
  updateAttachments: 'messages/updateAttachments',
  updateReplyAttachments: 'messages/updateReplyAttachments',

  messageError: 'messages/messageError'
}

const draftUrl = `/messages/${MessagesTabs.DRAFT}`
const sentUrl = `/messages/${MessagesTabs.SENT}`

export const actionCreators = {

  saveMessage: () => (dispatch, getState) => {
    dispatch({ type: actionTypes.messageAddOrUpdate })

    const state = getState()
    const request = { ...state.messages.message, attachments: state.messages.attachments.map(x => x.id) }
    context.api.messagesService.saveMessage(request)
      .then(response => {
        dispatch({ type: actionTypes.messageAddedOrUpdated, data: response })
        dispatch(push(draftUrl))
      })
      .catch(data => {
        openErrorDialog({ customErrorText: data.response.data.error.message })
        dispatch({ type: actionTypes.messageError, data: { messageAddOrUpdate: false } })
      })
  },

  saveMessageReply: () => (dispatch, getState) => {
    dispatch({ type: actionTypes.messageAddOrUpdate })

    const state = getState()
    const { message } = state.messages
    const request = {
      ...state.messages.replyMessage,
      messageParentId: message.id,
      attachments: state.messages.replyAttachments.map(x => x.id)
    }
    context.api.messagesService.saveMessageReply(request)
      .then(response => {
        dispatch({ type: actionTypes.messageAddedOrUpdated, data: response })
        dispatch(push(draftUrl))
      })
      .catch(data => {
        openErrorDialog({ customErrorText: data.response.error.message })
        dispatch({ type: actionTypes.messageError, data: { messageAddOrUpdate: false } })
      })
  },

  saveAndSendMessage: () => (dispatch, getState) => {
    dispatch({ type: actionTypes.messageAddOrUpdate })

    const state = getState()
    const request = { ...state.messages.message, attachments: state.messages.attachments.map(x => x.id) }

    context.api.messagesService.saveMessage(request)
      .then(response => {
        dispatch({ type: actionTypes.messageAddedOrUpdated, data: response })

        dispatch(actionCreators.sendMessage(response))
      })
      .catch(data => {
        openErrorDialog({ customErrorText: data.response.error.message })
        dispatch({ type: actionTypes.messageError, data: { messageAddOrUpdate: false } })
      })
  },

  saveAndSendMessageReply: () => (dispatch, getState) => {
    dispatch({ type: actionTypes.messageAddOrUpdate })

    const state = getState()
    const request = {
      ...state.messages.replyMessage,
      messageParentId: state.messages.message.id,
      attachments: state.messages.replyAttachments.map(x => x.id)
    }

    context.api.messagesService.saveMessageReply(request)
      .then(response => {
        dispatch({ type: actionTypes.messageAddedOrUpdated, data: response })

        dispatch(actionCreators.sendMessage(response))
      })
      .catch(data => {
        openErrorDialog({ customErrorText: data.response.error.message })
        dispatch({ type: actionTypes.messageError, data: { messageAddOrUpdate: false } })
      })
  },

  deleteMessage: (id) => (dispatch) => {
    dispatch({ type: actionTypes.messageDeleting })

    context.api.messagesService.delete(id)
      .then(response => {
        dispatch({ type: actionTypes.messageDeleted })
      })
      .catch(data => {
        openErrorDialog({ customErrorText: data.response.data.error.message })
        dispatch({ type: actionTypes.messageDeletingError, data: data })
      })
  },

  getMessage: (id, isReply) => (dispatch) => {
    if (isReply) {
      dispatch({ type: actionTypes.messageReplyRetrieving })
    } else {
      dispatch({ type: actionTypes.messageRetrieving })
    }

    context.api.messagesService.getMessage(id)
      .then(response => {
        if (isReply) {
          dispatch({ type: actionTypes.messageReplyRetrieved, data: response })
        } else {
          dispatch({ type: actionTypes.messageRetrieved, data: response })
          dispatch({ type: actionTypes.updateAttachments, data: response.attachments })
        }
      })
      .catch(error => {
        dispatch({ type: actionTypes.messageRetrievingError, data: error })
      })
  },

  getMessages: (id) => (dispatch, getState) => {
    dispatch({ type: actionTypes.messagesFetching })
    context.api.messagesService.getMessages({})
      .then(response => {
        dispatch({ type: actionTypes.messagesFetched, data: response.data })
      })
      .catch(error => {
        dispatch({ type: actionTypes.messagesFetchingError, data: error })
      })
  },

  sendMessage: (id) => (dispatch) => {
    dispatch({ type: actionTypes.messageSending })
    context.api.messagesService.sendMessage(id)
      .then(response => {
        dispatch({ type: actionTypes.messageSent, data: response.data })
        dispatch(push(sentUrl))
      })
      .catch(error => {
        dispatch({ type: actionTypes.messageSendingError, data: error })
      })
  },

  updateDto: (value, isReplyMessage) => (dispatch) => {
    if (isReplyMessage) {
      dispatch({ type: actionTypes.updateReplyDto, data: value })
    } else {
      dispatch({ type: actionTypes.updateDto, data: value })
    }
  },

  updateAttachments: (attachments, isReplyMessage) => (dispatch) => {
    if (isReplyMessage) {
      dispatch({ type: actionTypes.updateReplyAttachments, data: attachments })
    } else {
      dispatch({ type: actionTypes.updateAttachments, data: attachments })
    }
  },

  clearDto: () => (dispatch) => {
    dispatch({ type: actionTypes.clearDto })
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.messageAddOrUpdate:
      return { ...state, messageAddOrUpdate: true }
    case actionTypes.messageAddedOrUpdated:
      return {
        ...state,
        messageAddOrUpdate: false,
        messageAddedOrUpdated: true,
        message: {},
        attachments: [],
        replyMessage: {},
        replyAttachments: [],
        lastReloadedAtDraft: new Date(),
        lastReloadedAtSent: new Date(),
        data: action.data
      }
    case actionTypes.messageRetrieving:
      return { ...state, retrieved: false, retrieving: true }
    case actionTypes.messageRetrieved:
      return {
        ...state,
        retrieving: false,
        retrieved: true,
        message: action.data
      }
    case actionTypes.messageReplyRetrieving:
      return {
        ...state,
        replyRetrieved: false,
        replyRetrieving: true
      }
    case actionTypes.messageReplyRetrieved:
      return {
        ...state,
        replyRetrieving: false,
        replyRetrieved: true,
        message: action.data.messageParent,
        attachments: action.data.messageParent && action.data.messageParent.attachments,
        replyMessage: action.data,
        replyAttachments: action.data.attachments
      }
    case actionTypes.messageRetrievingError:
      return { ...state, retrieving: false, error: action.data }
    case actionTypes.messagesFetching:
      return { ...state, fetching: true }
    case actionTypes.messagesFetched:
      return { ...state, fetching: false, fetched: true, msg: action.data }
    case actionTypes.messagesFetchingError:
      return { ...state, fetching: false, error: action.data }
    case actionTypes.messageDeleting:
      return { ...state }
    case actionTypes.messageDeleted:
      return { ...state, lastReloadedAtDraft: new Date() }
    case actionTypes.messageDeletingError:
      return { ...state, error: action.data }
    case actionTypes.messageSending:
      return { ...state, messageSending: true }
    case actionTypes.messageSent:
      return { ...state, lastReloadedAtDraft: new Date(), lastReloadedAtSent: new Date(), messageSending: false }
    case actionTypes.messageSendingError:
      return { ...state, error: action.data, messageSending: false }
    case actionTypes.updateDto:
      return { ...state, message: { ...state.message, ...action.data } }
    case actionTypes.updateReplyDto:
      return { ...state, replyMessage: { ...state.replyMessage, ...action.data } }
    case actionTypes.clearDto:
      return {
        ...state,
        message: {},
        replyMessage: {},
        attachments: [],
        replyAttachments: [],
        retrieving: false,
        retrieved: false,
        replyRetrieving: false,
        replyRetrieved: false
      }
    case actionTypes.updateAttachments:
      return { ...state, attachments: [...action.data] }
    case actionTypes.updateReplyAttachments:
      return { ...state, replyAttachments: [...action.data] }
    case actionTypes.messageError:
      return { ...state, ...action.data }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/Messages.js